import {styled} from "@mui/material/styles";
import {Box} from "@mui/material";

const ContentContainer = styled(Box)(({theme}) => ({
  [theme.breakpoints.up('xxs')]: {
    padding: '22px 16px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '22px 20px',
  },
  [theme.breakpoints.up('lg')]: {
    padding: '30px 30px',
  },
}));

export default ContentContainer;
